import { render, staticRenderFns } from "./WarningCard.vue?vue&type=template&id=ce1c688e&scoped=true"
import script from "./WarningCard.vue?vue&type=script&lang=js"
export * from "./WarningCard.vue?vue&type=script&lang=js"
import style0 from "./WarningCard.vue?vue&type=style&index=0&id=ce1c688e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1c688e",
  null
  
)

export default component.exports